import { render, staticRenderFns } from "./MiniDepartmentTagIcon.vue?vue&type=template&id=9370b08a"
import script from "./MiniDepartmentTagIcon.vue?vue&type=script&lang=js"
export * from "./MiniDepartmentTagIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports